var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLeaveForBreak = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.833252H7.5V2.49992H12.5V0.833252ZM9.16667 11.6666H10.8333V6.66659H9.16667V11.6666ZM15.8583 6.15825L17.0417 4.97492C16.6833 4.54992 16.2917 4.14992 15.8667 3.79992L14.6833 4.98325C13.3917 3.94992 11.7667 3.33325 10 3.33325C5.85833 3.33325 2.5 6.69159 2.5 10.8333C2.5 14.9749 5.85 18.3333 10 18.3333C14.15 18.3333 17.5 14.9749 17.5 10.8333C17.5 9.06659 16.8833 7.44158 15.8583 6.15825ZM10 16.6666C6.775 16.6666 4.16667 14.0583 4.16667 10.8333C4.16667 7.60825 6.775 4.99992 10 4.99992C13.225 4.99992 15.8333 7.60825 15.8333 10.8333C15.8333 14.0583 13.225 16.6666 10 16.6666Z",
    fill: "#6D6F71"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLeaveForBreak, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/LeaveForBreak.08d84536.svg";
export { ForwardRef as ReactComponent };